<!--
    Rendered unconditionally so the viewChild resolves before the first message arrives -- aix-modal
    renders nothing of its own until openModal() is called.
-->
<aix-modal
    #announcementsModal
    [closeable]="false"
    [modalTitle]="modalTitle"
    [modalType]="'interactive'"
    [modalZIndex]="7000"
    [buttonOptions]="buttonOptions"
    (optionSelected)="onOptionSelected()"
    (onCloseModal)="onCloseModal()"
>
    <ng-template>
        @if (message) { @if (messageIsStyled) {
        <!--
            The message styles itself, so it gets its own document. Inlining a stylesheet written
            for a standalone page would have it redecorate the app around it, and the alternative --
            stripping the <style> out, which is what aixSanitize does -- is what left these
            rendering unstyled.

            Sandboxed without allow-scripts, so nothing in the message can run. allow-same-origin
            is what lets us measure its height from out here; harmless on its own, since the pair of
            them is what would hand sponsor markup a way back into the app.

            The two popup flags are what make the base target="_blank" links work at all: a
            sandboxed frame cannot open a window without allow-popups, and -to-escape-sandbox is
            what stops the opened tab from inheriting these restrictions and rendering the
            sponsor's own site crippled. Neither widens what the frame itself can do, and without
            allow-scripts a popup still needs the user to click a link.
        -->
        <iframe
            class="announcement-frame"
            [title]="message.title || 'Announcement'"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            [srcdoc]="message.textHTML | aixSanitizeDocument"
            [style.height.px]="frameHeight"
            (load)="onFrameLoad($event)"
        ></iframe>
        } @else {
        <!--
            Plain markup, which inherits the app's own styling. aixSanitize strips it through the
            allowlist in ui-utils/security before trusting it -- NOT the similarly named sanitizeHtml
            pipe in app-components, which trusts its input unchanged.
        -->
        <div class="u-mb16" [innerHTML]="message.textHTML | aixSanitize"></div>
        } }
    </ng-template>
</aix-modal>
